// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import type { CapabilityAudio } from "@dsbunny/capdb-schema";
import { kAudioCanvases } from "./canvases.js";

// Returns an array of audio decoding capabilities for each codec and container.
// Assumes that the MediaCapabilities API is available.
export async function audioDecodingInfo(): Promise<Array<CapabilityAudio>> {
	if(!('mediaCapabilities' in navigator)) {
		throw new Error('MediaCapabilities API not available');
	}
	const capabilities: Array<CapabilityAudio> = [];
	for(const canvas of kAudioCanvases) {
		let is_supported = false;
		let is_smooth = false;
		let is_power_efficient = false;
		try {
			const result = await navigator.mediaCapabilities.decodingInfo({
				type: "file",
				// Note that `AudioDecoder` only supports integer channel counts,
				// so must use `mediaCapabilities` for channel counts.
				audio: {
					contentType: `${canvas.mimeType}; codecs="${canvas.codec}"`,
					samplerate: canvas.sample_rate,
					channels: `${canvas.channels}`,
				}
			});
			is_supported = result.supported;
			is_smooth = result.smooth;
			is_power_efficient = result.powerEfficient;
		} catch {
			// Ignore errors
		}
		const capability: CapabilityAudio = {
			mime_type: 'audio',
			mime_subtype: canvas.mimeType.split('/')[1],
			codec: canvas.codec,
			sample_rate: canvas.sample_rate,
			channels: `${canvas.channels}`,
			is_supported,
			is_smooth,
			is_power_efficient,
		};
		capabilities.push(capability);
	}
	return capabilities;
}
